import type { H3Event, EventHandlerRequest } from "h3";

export const useHconConfig = (event?: H3Event<EventHandlerRequest>):any => {
    const rcfg  = useRuntimeConfig(event);

    return import.meta.server ? rcfg.hcon : rcfg.public.hcon;
}

